export enum IDENTITY_PROVIDERS {
    /**
     * @value API token
     * @description This is the API token used for user synchronisation with Okta.
     */
    API_TOKEN = 'ADMIN.PROVIDER.API_TOKEN',
    /**
     * @value The API token is used for tracking API calls
     */
    API_TOKEN_HELPER = 'ADMIN.PROVIDER.API_TOKEN_HELPER',
    /**
     * @value Force login to Login Provider
     */
    AUTHENTICATE_EACH_LOGIN_ENABLED = 'ADMIN.PROVIDER.AUTHENTICATE_EACH_LOGIN_ENABLED',
    /**
     * @value Force the connection to the login provider portal for each user login via SAML to refresh the integrations tokens.
     */
    AUTHENTICATE_EACH_LOGIN_HELPER = 'ADMIN.PROVIDER.AUTHENTICATE_EACH_LOGIN_HELPER',
    /**
     * @value Force login for all users from this source, using their source credentials.
     */
    AUTO_SYNC_HELPER = 'ADMIN.PROVIDER.AUTO_SYNC_HELPER',
    /**
     * @value Automatic login
     */
    AUTO_SYNC_LABEL = 'ADMIN.PROVIDER.AUTO_SYNC_LABEL',
    /**
     * @value Background color
     */
    BACKGROUND_COLOR = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.BACKGROUND_COLOR',
    /**
     * @value Beekeeper
     */
    BEEKEEPER = 'IDENTITY_PROVIDER.BEEKEEPER',
    /**
     * @value Client Credentials
     */
    CRED = 'ADMIN.PROVIDER.CRED',
    /**
     * @value Client ID
     */
    CRED_CLIENT_ID = 'ADMIN.PROVIDER.CRED_CLIENT_ID',
    /**
     * @value Public identifier for the client that is required for all OAuth flows
     */
    CRED_CLIENT_ID_HELPER = 'ADMIN.PROVIDER.CRED_CLIENT_ID_HELPER',
    /**
     * @value Client Secret
     */
    CRED_SECRET = 'ADMIN.PROVIDER.CRED_SECRET',
    /**
     * @value Secret used by the client to exchange an authorization code for a token. This must be kept confidential. Do not include it in apps which cannot keep it secret, such as those running on a client.
     */
    CRED_SECRET_HELPER = 'ADMIN.PROVIDER.CRED_SECRET_HELPER',
    /**
     * @value Login domain
     */
    CUSTOMER_LOGIN_DOMAIN = 'ADMIN_RESELLER_CONSOLE_CUSTOMER_LOGIN_DOMAIN',
    /**
     * @value Redirect users to the specified login domain
     */
    CUSTOMER_SSO_DOMAIN_HINT = 'ADMIN_RESELLER_CONSOLE_CUSTOMER_SSO_DOMAIN_HINT',
    /**
     * @value Sync the "hide this user" field
     */
    CUSTOMER_SYNC_HIDE_USER = 'ADMIN_RESELLER_CONSOLE_CUSTOMER_SYNC_HIDE_USER',
    /**
     * @value Synchronize the field "hide this user" from the identity provider directory
     */
    CUSTOMER_SYNC_HIDE_USER_HELP = 'ADMIN_RESELLER_CONSOLE_CUSTOMER_SYNC_HIDE_USER_HELP',
    /**
     * @value Are you sure you want to delete this provider?
     */
    DELETE_CONFIRM_CONTENT = 'ADMIN.PROVIDER.DELETE_CONFIRM_CONTENT',
    /**
     * @value Delete provider
     */
    DELETE_CONFIRM_TITLE = 'ADMIN.PROVIDER.DELETE_CONFIRM_TITLE',
    /**
     * @value An error occurred when deleting the provider.
     */
    DELETE_ERROR = 'ADMIN.PROVIDER.DELETE.ERROR',
    /**
     * @value The provider has been deleted successfully.
     */
    DELETE_SUCCESS = 'ADMIN.PROVIDER.DELETE.SUCCESS',
    /**
     * @value Existing LumApps users remain active when provisioning is disabled.
     */
    DISABLE_PROVISIONING_WARNING = 'ADMIN.PROVIDER.DISABLE_PROVISIONING_WARNING',
    /**
     * @value An error occurred while retrieving metadata file
     */
    DOWNLOAD_SP_ERROR = 'ADMIN.PROVIDER.DOWNLOAD_SP.ERROR',
    /**
     * @value Edit provider
     */
    EDIT_PROVIDER = 'ADMIN.PROVIDER.EDIT_PROVIDER',
    /**
     * @value You can edit your identity providers in the section
     */
    EDIT_PROVIDER_INFO_MESSAGE = 'ADMIN.PROVIDER.INFO_MESSAGE.EDIT_PROVIDER',
    /**
     * @value "Installed extensions"
     */
    EDIT_PROVIDER_LINK_TEXT = 'ADMIN.PROVIDER.INFO_MESSAGE.EDIT_PROVIDER_LINK_TEXT',
    /**
     * @value This section gives you access to identity providers
     */
    EMPTY_STATE_DESCRIPTION = 'PROVIDERS.EMPTY_STATE_DESCRIPTION',
    /**
     * @value There are no identity providers yet
     */
    EMPTY_STATE_TITLE = 'PROVIDERS.EMPTY_STATE_TITLE',
    /**
     * @value Each time the "Enable login" is activated, a manual user synchronization is required before users can log in. Please contact the Support team. More information about the user synchronization can be found in the %DOCUMENTATION%.
     */
    ENABLE_LOGIN_INFO = 'IDENTITY_PROVIDERS.ENABLE_LOGIN_INFO',
    /**
     * @value Enable magic link login
     */
    ENABLE_MAGIC_LINK_LOGIN = 'ADMIN.PROVIDER.ENABLE_MAGIC_LINK_LOGIN',
    /**
     * @value Enable password login
     */
    ENABLE_PASSWORD_LOGIN = 'ADMIN.PROVIDER.ENABLE_PASSWORD_LOGIN',
    /**
     * @value Exceptions
     */
    EXCEPTIONS = 'ADMIN.PROVIDER.EXCEPTIONS',
    /**
     * @value Condition
     */
    EXCEPTIONS_FIELD_CONDITION = 'ADMIN.PROVIDER.EXCEPTIONS_FIELD_CONDITION',
    /**
     * @value Field name
     */
    EXCEPTIONS_FIELD_NAME = 'ADMIN.PROVIDER.EXCEPTIONS_FIELD_NAME',
    /**
     * @value Field type
     */
    EXCEPTIONS_FIELD_TYPE = 'ADMIN.PROVIDER.EXCEPTIONS_FIELD_TYPE',
    /**
     * @value Field value
     */
    EXCEPTIONS_FIELD_VALUE = 'ADMIN.PROVIDER.EXCEPTIONS_FIELD_VALUE',
    /**
     * @value Prevent the synchronization of selected user accounts by selecting a user profile field and a value. Users with this field set to this value are excluded from the daily synchronization.
     */
    EXCEPTIONS_HELPER = 'ADMIN.PROVIDER.EXCEPTIONS_HELPER',
    /**
     * @value Download file and import it in your identity provider
     */
    EXPORT_METADATA_HELPER = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.EXPORT_METADATA_HELPER',
    /**
     * @value Extranet feature
     */
    EXTRANET_FEATURE = 'ADMIN.PROVIDER.EXTRANET_OPTION_TITLE',
    /**
     * @value Users created with this provider will be added as members of the selected groups.
     */
    EXTRANET_GROUP_PICKER_HELPER = 'ADMIN.PROVIDER.GROUP_PICKER_HELPER',
    /**
     * @value Automatic group membership
     */
    EXTRANET_GROUP_PICKER_LABEL = 'ADMIN.PROVIDER.GROUP_PICKER_LABEL',
    /**
     * @value Select sites to show the login button on
     */
    EXTRANET_INSTANCE_PICKER_LABEL = 'ADMIN.PROVIDER.INSTANCE_PICKER_LABEL',
    /**
     * @value Show login button in selected sites only
     */
    EXTRANET_VISIBILITY_INSTANCE_HELPER = 'ADMIN.PROVIDER.VISIBILITY_INSTANCE_HELPER',
    /**
     * @value Show login button in all platform sites
     */
    EXTRANET_VISIBILITY_PLATFORM_HELPER = 'ADMIN.PROVIDER.VISIBILITY_PLATFORM_HELPER',
    /**
     * @value Enable the federation on the "Employee ID" field
     */
    FEDERATE_ON_EMPLOYEEID = 'ADMIN.PROVIDER.FEDERATE_ON_EMPLOYEEID',
    /**
     * @value During the synchronization, the users will be federated using the "Employee ID" field
     */
    FEDERATE_ON_EMPLOYEEID_HELPER = 'ADMIN.PROVIDER.FEDERATE_ON_EMPLOYEEID_HELPER',
    /**
     * @deprecated use ReferToDocumentation component instead
     * @value For more information, refer to the
     * @description a space should be present at the end of this sentence.
     */
    FOR_MORE_INFO_REFER_TO = 'ADMIN.PROVIDER.FOR_MORE_INFO_REFER_TO',
    /**
     * @value Enable integrations for existing users only
     */
    HAS_INTEGRATION_ONLY = 'ADMIN.PROVIDER.HAS_INTEGRATION_ONLY',
    /**
     * @value Users are never created from this provider but the existing users can use its integrations
     */
    HAS_INTEGRATION_ONLY_HELPER = 'ADMIN.PROVIDER.HAS_INTEGRATION_ONLY_HELPER',
    /**
     * @value Identity providers
     */
    IDP = 'ADMIN.NAV.PROVIDER.IDP',
    /**
     * @value Metadata file generated by your identity provider
     */
    IMPORT_METADATA_HELPER = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.IMPORT_METADATA_HELPER',
    /**
     * @value Allow on-the-fly user creation
     */
    JIT_ENABLED = 'ADMIN.PROVIDER.JIT_ENABLED',
    /**
     * @value Allow JIT (Just-in-Time) provisioning for this SAML provider. Users will be created if they do not exist in the Intranet.
     */
    JIT_ENABLED_HELPER = 'ADMIN.PROVIDER.JIT_ENABLED_HELPER',
    /**
     * @value Login button
     */
    LOGIN_BUTTON = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.LOGIN_BUTTON',
    /**
     * @value Choose the appearance of the button.
     */
    LOGIN_BUTTON_HELPER = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.LOGIN_BUTTON_HELPER',
    /**
     * @value Please upload a square image less than 300 KB.
     */
    LOGIN_BUTTON_INFO = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.LOGIN_BUTTON_INFO',
    /**
     * @value Enable login
     */
    LOGIN_ENABLED = 'ADMIN.PROVIDER.LOGIN_ENABLED',
    /**
     * @value Displays the login button for this provider on the login page
     */
    LOGIN_ENABLED_HELPER = 'ADMIN.PROVIDER.LOGIN_ENABLED_HELPER',
    /**
     * @value Fill login hint field
     */
    LOGIN_HINT_ENABLED = 'ADMIN.PROVIDER.LOGIN_HINT_ENABLED',
    /**
     * @value Allow LumApps to use the email address on login provider portal to pre-fill the connection form (Microsoft) or pre-select the right account (Google).
     */
    LOGIN_HINT_HELPER = 'ADMIN.PROVIDER.LOGIN_HINT_HELPER',
    /**
     * @value LumApps Provider
     * @description Name of the LumApps (email and password) identity provider: its row in the identity providers list, the header of its dialog and the title of its settings page.
     */
    LUMAPPS_PROVIDER = 'IDENTITY_PROVIDERS.LUMAPPS_PROVIDER',
    /**
     * @value Using metadata descriptor XML
     */
    METADATA_HELPER = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.METADATA_HELPER',
    /**
     * @value This option requires Office 365 login authorizations. Please <a href="https://azure-enterprise-application.lumapps.net/" target="_blank" class="tc-primary">grant access to LumApps</a>.
     */
    MICROSOFT_HELPER = 'ADMIN.PROVIDER.MICROSOFT.HELPER',
    /**
     * @value Client ID SDK for mobile authentication
     */
    MOBILE_OKTA_CLIENT_ID_SDK = 'RESELLER_CONSOLE.MOBILE_OKTA_CLIENT_ID_SDK',
    /**
     * @value Public identifier for the client that is required for all OAuth mobile flows. This feature improves security and supports more use cases like passkeys sign-in. If empty, the web client id will be used.
     */
    MOBILE_OKTA_CLIENT_ID_SDK_HELPER = 'RESELLER_CONSOLE.MOBILE_OKTA_CLIENT_ID_SDK_HELPER',
    /**
     * @value Mobile client credentials (only to configure the SDK for mobile native integration)
     */
    MOBILE_OKTA_CRED_SDK = 'RESELLER_CONSOLE.MOBILE_OKTA_CRED_SDK',
    /**
     * @value Choose which SAML attribute is matched to a user during login
     * @description Helper text for the SAML name ID type selector
     */
    NAME_ID_TYPE_HELPER = 'ADMIN.IDENTITY_PROVIDERS.NAME_ID_TYPE_HELPER',
    /**
     * @value Name ID type
     * @description Label for the SAML name ID type selector
     */
    NAME_ID_TYPE_LABEL = 'ADMIN.IDENTITY_PROVIDERS.NAME_ID_TYPE_LABEL',
    /**
     * @value Provider user ID
     * @description SAML name ID type option: match users by their provider user ID
     */
    NAME_ID_TYPE_OPTION_PROVIDER_USER_ID = 'ADMIN.IDENTITY_PROVIDERS.NAME_ID_TYPE_OPTION_PROVIDER_USER_ID',
    /**
     * @value Automatic
     * @description SAML name ID type option: automatically deduced
     */
    NAME_ID_TYPE_OPTION_UNSET = 'ADMIN.IDENTITY_PROVIDERS.NAME_ID_TYPE_OPTION_UNSET',
    /**
     * @value A new certificate for the year to come is available.
     */
    NEW_CERTIFICATE_VERSION_INFO = 'ADMIN.IDENTITY_PROVIDERS.NEW_CERTIFICATE_VERSION_INFO',
    /**
     * @value New provider
     */
    NEW_PROVIDER = 'ADMIN.PROVIDER.NEW_PROVIDER',
    /**
     * @value Options
     */
    OPTIONS = 'ADMIN.PROVIDER.OPTIONS',
    /**
     * @value Force login for all users through the redirection, using their source credentials
     */
    PROVIDER_AUTO_LOGIN_REDIRECT_HELPER = 'ADMIN.PROVIDER.AUTO_LOGIN_REDIRECT_HELPER',
    /**
     * @value Enable login redirection
     */
    PROVIDER_LOGIN_REDIRECT = 'ADMIN.PROVIDER.LOGIN_REDIRECT',
    /**
     * @value Redirect to the personalized login process
     */
    PROVIDER_LOGIN_REDIRECT_HELPER = 'ADMIN.PROVIDER.LOGIN_REDIRECT_HELPER',
    /**
     * @value Choose where the login button is visible
     */
    PROVIDER_LOGIN_VISIBILITY_HELPER = 'ADMIN.PROVIDER.LOGIN_VISIBILITY_HELPER',
    /**
     * @value Visibility of the login button
     */
    PROVIDER_LOGIN_VISIBILITY_LABEL = 'ADMIN.PROVIDER.LOGIN_VISIBILITY_LABEL',
    /**
     * @value Mobile application
     */
    PROVIDER_LOGIN_VISIBILITY_MOBILE = 'ADMIN.PROVIDER.LOGIN_VISIBILITY_MOBILE',
    /**
     * @value Web
     */
    PROVIDER_LOGIN_VISIBILITY_WEB = 'ADMIN.PROVIDER.LOGIN_VISIBILITY_WEB',
    /**
     * @value Web & Mobile application
     */
    PROVIDER_LOGIN_VISIBILITY_WEBANDMOBILE = 'ADMIN.PROVIDER.LOGIN_VISIBILITY_WEBANDMOBILE',
    /**
     * @value Provider management
     */
    PROVIDER_MANAGEMENT = 'ADMIN.PROVIDER.PROVIDER_MANAGEMENT',
    /**
     * @value Select a value
     */
    PROVIDER_SELECT_VALUE = 'GLOBAL.INPUT.SELECT_VALUE',
    /**
     * @value Provider reference
     */
    PROVIDER_URL_REFERENCE = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.PROVIDER_URL_REFERENCE',
    /**
     * @value Enable user provisioning
     */
    PROVISIONING_ENABLED = 'ADMIN.PROVIDER.PROVISIONING_ENABLED',
    /**
     * @value This provider will be used during the user synchronization
     */
    PROVISIONING_ENABLED_HELPER = 'ADMIN.PROVIDER.PROVISIONING_ENABLED_HELPER',
    /**
     * @value Okta access has failed, review information for "Source" and "Client credentials" sections.
     */
    PROVISIONING_SOURCE_ERROR = 'ADMIN.PROVIDER.PROVISIONING_SOURCE_ERROR',
    /**
     * @value Provisioning endpoint
     * @description Label used to show an URL linked to provisioning.
     */
    PROVISIONING_URL = 'ADMIN.PROVIDER.PROVISIONING_URL',
    /**
     * @value The provisioning endpoint is shown for information purpose only.
     */
    PROVISIONING_URL_INFO = 'ADMIN.PROVIDER.PROVISIONING_URL_INFO',
    /**
     * @value No endpoint to display. <br> there is no automatic daily provisioning set up for this provider
     */
    PROVISIONING_URL_MISSING = 'ADMIN.PROVIDER.PROVISIONING_URL_MISSING',
    /**
     * @value Federation has stopped for
     * @description Status message displayed to show if setup has errors or not.
     * Message is split in 3 KEYS : This one + number of errors + end of the message.
     */
    PROV_FEDERATION_ERROR_BEGIN = 'PROV_FEDERATION.ERROR_BEGIN',
    /**
     * @value because of errors.
     * @description Status message displayed to show if setup has errors or not.
     * Message is split in 3 KEYS : begin of the message + number of errors + end of the message.
     */
    PROV_FEDERATION_ERROR_END = 'PROV_FEDERATION.ERROR_END',
    /**
     * @value Users federation successful
     * @description Status message displayed to show if setup has errors or not
     */
    PROV_FEDERATION_SUCCESS = 'PROV_FEDERATION.SUCCESS',
    /**
     * @value The identity provider quota of this customer has been reached.
     */
    QUOTA_EXCEED = 'ADMIN.PROVIDER.QUOTA.EXCEED',
    /**
     * @value Redirect to Login Provider
     */
    REDIRECT_ENABLED = 'ADMIN.PROVIDER.REDIRECT_ENABLED',
    /**
     * @value Authorize LumApps to redirect after SAML login to the login provider portal to get the integration token.
     */
    REDIRECT_HELPER = 'ADMIN.PROVIDER.REDIRECT_HELPER',
    /**
     * @value Require 2-step verification
     * @description Label of the switch enabling two-factor authentication on the LumApps (email) identity provider.
     */
    REQUIRE_TWO_STEP_VERIFICATION = 'ADMIN.PROVIDER.REQUIRE_TWO_STEP_VERIFICATION',
    /**
     * @value Users must confirm their identity with a link sent by email after signing in with their password. Magic link login is turned off while 2-step verification is enabled.
     * @description Helper text under the two-factor authentication switch, explaining that magic link login is disabled while it is on.
     */
    REQUIRE_TWO_STEP_VERIFICATION_HELPER = 'ADMIN.PROVIDER.REQUIRE_TWO_STEP_VERIFICATION_HELPER',
    /**
     * @value Required while 2FA is enabled
     * @description Tooltip on the password login switch, explaining why it is locked on while two-factor authentication is enabled.
     */
    REQUIRED_WHILE_TWO_STEP_VERIFICATION_ENABLED = 'ADMIN.PROVIDER.REQUIRED_WHILE_TWO_STEP_VERIFICATION_ENABLED',
    /**
     * @value Unavailable while 2FA is enabled
     * @description Tooltip on the magic link login switch, explaining why it is locked off while two-factor authentication is enabled.
     */
    UNAVAILABLE_WHILE_TWO_STEP_VERIFICATION_ENABLED = 'ADMIN.PROVIDER.UNAVAILABLE_WHILE_TWO_STEP_VERIFICATION_ENABLED',
    /**
     * @value Can't determine which provider's domain you wanted to use.
     */
    SAVE_DOMAIN_ERROR = 'ADMIN.PROVIDER.SAVE.DOMAIN_ERROR',
    /**
     * @value An error occurred when saving the provider.
     */
    SAVE_ERROR = 'ADMIN.PROVIDER.SAVE.ERROR',
    /**
     * @value The provider has been saved successfully.
     */
    SAVE_SUCCESS = 'ADMIN.PROVIDER.SAVE.SUCCESS',
    /**
     * @value LumApps identity provider
     */
    SCIM_PROVIDER_TYPE = 'ADMIN.PROVIDER.SCIM_PROVIDER_TYPE',
    /**
     * @value Bind users and groups to the LumApps identity provider
     */
    SCIM_PROVIDER_TYPE_PLACEHOLDER = 'ADMIN.PROVIDER.SCIM_PROVIDER_TYPE_PLACEHOLDER',
    /**
     * @value See our documentation.
     */
    SEE_OUR_DOC = 'ADMIN.GLOBAL.SEE_OUR_DOC',
    /**
     * @value An error occurred when deleting the user space.
     */
    SERVICE_DELETE_USERSPACE_ERROR = 'ADMIN.PROVIDER.SERVICE.DELETE_USERSPACE_ERROR',
    /**
     * @value The user space has been deleted successfully.
     */
    SERVICE_DELETE_USERSPACE_SUCCESS = 'ADMIN.PROVIDER.SERVICE.DELETE_USERSPACE_SUCCESS',
    /**
     * @value Error while retrieving provider list
     */
    SERVICE_FETCH_PROVIDER_ERROR = 'ADMIN.PROVIDER.SERVICE.FETCH_PROVIDER_ERROR',
    /**
     * @value Error while retrieving user space information
     */
    SERVICE_FETCH_USERSPACE_DETAIL_ERROR = 'ADMIN.PROVIDER.SERVICE.FETCH_USERSPACE_DETAIL_ERROR',
    /**
     * @value Error while retrieving user space list
     */
    SERVICE_FETCH_USERSPACE_ERROR = 'ADMIN.PROVIDER.SERVICE.FETCH_USERSPACE_ERROR',
    /**
     * @value An error occurred when saving the user space.
     */
    SERVICE_SAVE_USERSPACE_ERROR = 'ADMIN.PROVIDER.SERVICE.SAVE_USERSPACE_ERROR',
    /**
     * @value The user space has been saved successfully.
     */
    SERVICE_SAVE_USERSPACE_SUCCESS = 'ADMIN.PROVIDER.SERVICE.SAVE_USERSPACE_SUCCESS',
    /**
     * @value Signing certificate version
     */
    SIGNING_CERTIFICATE_VERSION = 'ADMIN.IDENTITY_PROVIDERS.SIGNING_CERTIFICATE_VERSION',
    /**
     * @value One month before the current certificate expires, a new certificate will appear here. You can switch to it at any time before the expiration date.
     */
    SIGNING_CERTIFICATE_VERSION_DESCRIPTION = 'ADMIN.IDENTITY_PROVIDERS.SIGNING_CERTIFICATE_VERSION_DESCRIPTION',
    /**
     * @value Source
     */
    SOURCE = 'ADMIN.PROVIDER.SOURCE',
    /**
     * @value Enable Single Sign-On
     */
    SSO_ENABLED = 'ADMIN.PROVIDER.SSO_ENABLED',
    /**
     * @value Manage authentication of all Google apps with LumApps
     */
    SSO_ENABLED_HELPER = 'ADMIN.PROVIDER.SSO_ENABLED_HELPER',
    /**
     * @value Synchronize only users included in the Okta application linked to LumApps
     */
    SYNC_APPLICATION_ONLY = 'ADMIN.PROVIDER.SYNC_APPLICATION_ONLY',
    /**
     * @value Restrict the provisioning to users included in the Okta application linked to LumApps
     */
    SYNC_APPLICATION_ONLY_HELPER = 'ADMIN.PROVIDER.SYNC_APPLICATION_ONLY_HELPER',
    /**
     * @value When you enable this option, you must ensure that the User profile mapping with Okta is correct.
     */
    SYNC_APPLICATION_ONLY_WARNING = 'ADMIN.PROVIDER.SYNC_APPLICATION_ONLY_WARNING',
    /**
     * @value Synchronization from LumApps to G Suite
     */
    SYNC_TO_GSUITE = 'ADMIN.PROVIDER.SYNC_TO_GSUITE',
    /**
     * @value Action
     */
    TABLE_HEADER_ACTION = 'ADMIN.PROVIDER.TABLE_HEADER_ACTION',
    /**
     * @value Last synchronization
     */
    TABLE_HEADER_LAST_SYNC = 'ADMIN.PROVIDER.TABLE_HEADER_LAST_SYNC',
    /**
     * @value Provider
     */
    TABLE_HEADER_PROVIDER = 'ADMIN.PROVIDER.TABLE_HEADER_PROVIDER',
    /**
     * @value Technical account used for synchronization.
     */
    TECHNICAL_ACCOUNT = 'ADMIN.PROVIDER.TECHNICAL_ACCOUNT',
    /**
     * @value To create a technical account, refer to the <a href="https://docs.lumapps.com/docs/install-l0027254914098205907google-install#l43815895359036405" target="_blank" class="tc-primary">documentation</a>.
     */
    TECHNICAL_ACCOUNT_HELPER = 'ADMIN.PROVIDER.TECHNICAL_ACCOUNT.HELPER',
    /**
     * @value Upload a logo
     */
    UPLOAD_LOGO = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.UPLOAD_LOGO',
    /**
     * @value Import metadata file generated by your identity provider
     */
    UPLOAD_METADATA = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.UPLOAD_METADATA',
    /**
     * @value Show applications in the launcher
     */
    USE_BOOKMARKS = 'ADMIN.PROVIDER.USE_BOOKMARKS',
    /**
     * @value Add the provider apps in the top bar launcher
     */
    USE_BOOKMARKS_HELPER = 'ADMIN.PROVIDER.USE_BOOKMARKS_HELPER',
    /**
     * @value Tenant ID/Domain will be available after saving
     */
    VALIDATION_AFTER_SAVING = 'ADMIN.PROVIDER.DOMAIN.VALIDATION_AFTER_SAVING',
    /**
     * @value Sign in with your account to add the tenant ID / domain
     */
    VERIF_AFTER_LOGIN = 'ADMIN.PROVIDER.DOMAIN.VERIF_AFTER_LOGIN',
}
